import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field } from 'redux-form';

// Components
import { Row, Col } from 'reactstrap';
import InputField from 'components/atoms/InputField';
import FieldSwitch from 'components/atoms/FieldSwitch';

// utils
import { isTrue } from 'utils/varValidation';
import { NUMERIC_REGEX } from 'utils/regex';
import { isPhoneNumberValid, formatPhoneNumber } from 'utils/string';

import './RemindersAndUpdates.scss';

// Constants
import { APP_FLOW } from 'constants/appFlow';
import { APPOINTMENT_STATUS } from 'constants/appointmentStatus';
import { C8_TOGGLE_PRIVACY_SETTINGS_VALUES } from 'constants/privacySettings';

const { LOG_ME_IN } = APP_FLOW;
const { NEW } = APPOINTMENT_STATUS;

const ns = 'reminders';

class RemindersAndUpdates extends Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
    this.onChangeToggle = this.onChangeToggle.bind(this);
    const isEmailPrivacySettingOn =
      props.privacySettings &&
      +props.privacySettings.emailPrivacySetting[0] > 0;
    const isTextPrivacySettingOn =
      props.privacySettings && +props.privacySettings.textPrivacySetting[0] > 0;
    this.state = {
      text: isTextPrivacySettingOn,
      email: isEmailPrivacySettingOn
    };
  }

  componentDidMount() {
    const { text } = this.state;
    if (text) {
      this.getMobileNumber();
    }
  }

  setRemindersAndUpdates() {
    const { setPrivacySettings } = this.props;
    const { email, text } = this.state;
    const privacySettings = {
      emailPrivacySetting: email
        ? C8_TOGGLE_PRIVACY_SETTINGS_VALUES.EMAIL_ENABLED
        : C8_TOGGLE_PRIVACY_SETTINGS_VALUES.EMAIL_DISABLED,
      textPrivacySetting: text
        ? C8_TOGGLE_PRIVACY_SETTINGS_VALUES.TEXT_ENABLED
        : C8_TOGGLE_PRIVACY_SETTINGS_VALUES.TEXT_DISABLED
    };
    setPrivacySettings(privacySettings);
  }

  getMobileNumber() {
    const {
      setMobilePhoneNumber,
      showPhoneNumber,
      savedMobileNumber
    } = this.props;
    setMobilePhoneNumber(savedMobileNumber || showPhoneNumber);
    // ToDo - this condition was deactivated cause mobile phone number should be showed in all flows acording the defect DE57823 but it has been implemented on US193296.
    /* if (appFlow === IM_NEW_HERE) {
      mobilePhoneNumberNotPopulated();
    } */
  }

  onChangeToggle = ({ target: { id, checked } }) => {
    this.setState(
      {
        [id]: checked
      },
      () => this.setRemindersAndUpdates()
    );
  };

  renderInputField = field => {
    const {
      dealerCountryCode,
      intl,
      contactInfo: { mobilePhone }
    } = this.props;
    const {
      meta: { error },
      type,
      className,
      maskReg
    } = field;
    const isValid = !this.mobilePhoneValidate(mobilePhone);
    const iconAriaLabel =
      field.input.name === 'mobilePhone'
        ? intl.formatMessage({
            id: 'c8.aria.reminder.and.update.phone.number',
            defaultMessage: 'Reminder and update phone number'
          })
        : '';
    const inputAriaLabel = intl.formatMessage({
      id: 'c8.aria.reminder.and.update.input.phone.number',
      defaultMessage: 'Introduce phone number to send text messages'
    });

    let classProps = classNames(className);

    field.input.value = formatPhoneNumber(mobilePhone, dealerCountryCode);

    if (!isValid) {
      classProps = classNames(className, {
        invalid: error
      });
    }

    return (
      <InputField
        className={classProps}
        placeholder={field.placeholder}
        leftAddonConf={field.leftAddonConf}
        maskReg={maskReg || null}
        type={type}
        inputConf={{
          ...field.input,
          onChange: e => {
            this.onInputChange(e);
            field.input.onChange(e);
          }
        }}
        iconAriaLabel={iconAriaLabel}
        inputAriaLabel={inputAriaLabel}
      />
    );
  };

  showPhoneNumberField() {
    const {
      intl,
      appFlow,
      isObfuscated,
      appointmentStatus,
      contactInfo: { mobilePhone }
    } = this.props;
    const isOnlyView =
      (appointmentStatus !== NEW && isObfuscated) || appFlow === LOG_ME_IN;
    return isOnlyView ? (
      <p className={'clase-placeholder'}>{mobilePhone}</p>
    ) : (
      <Field
        name="mobilePhone"
        className={`${ns}__mobile-number-input-field`}
        placeholder={intl.formatMessage({
          id: 'c8.review.mobile.phone.no'
        })}
        type="tel"
        maskReg={NUMERIC_REGEX}
        leftAddonConf={{
          addonValue: 'oldMobile',
          isGlyhicon: true
        }}
        component={this.renderInputField}
        validate={this.mobilePhoneValidate}
      />
    );
  }

  onInputChange = event => {
    const {
      setMobilePhoneNumber,
      isObfuscated,
      resetObfuscatedContactInfo,
      mobilePhoneNumberModified,
      setObfuscatedBy
    } = this.props;
    const { value } = event.target;
    let inputValue;
    if (!isObfuscated) {
      inputValue = value;
    } else {
      inputValue = '';
      resetObfuscatedContactInfo();
      setObfuscatedBy(null);
    }
    setMobilePhoneNumber(inputValue);
    mobilePhoneNumberModified();
  };

  mobilePhoneValidate = value => {
    const { dealerCountryCode, isObfuscated } = this.props;
    return (!isObfuscated && !isPhoneNumberValid(value, dealerCountryCode)) ||
      (value && value.length <= 4)
      ? 'Invalid phone number'
      : undefined;
  };

  render() {
    const { getTranslate, intl, isDmsAppt } = this.props;
    const { text, email } = this.state;
    return isTrue(getTranslate('c8.appointment.option.email')) ||
      isTrue(getTranslate('c8.appointment.option.sms')) ? (
      <React.Fragment>
        <Row className={ns} id={`${ns}_section`}>
          <Col xs={12} className={`${ns}__title`}>
            {intl
              .formatMessage({
                id: 'c8.review.update.notification.preferences',
                defaultMessage: 'Update Notification Preferences'
              })
              .toUpperCase()}
          </Col>
          <Col xs={6}>
            {isTrue(getTranslate('c8.appointment.option.sms')) && (
              <FieldSwitch
                label={intl.formatMessage({ id: 'c8.common.text' })}
                name={'text'}
                onChange={e => {
                  this.getMobileNumber();
                  this.onChangeToggle(e);
                }}
                checked={text}
                className={'text'}
                disabled={isDmsAppt}
              />
            )}
          </Col>
          <Col xs={6} className={`${ns}__text-toggle`}>
            {isTrue(getTranslate('c8.appointment.option.email')) && (
              <FieldSwitch
                label={intl.formatMessage({ id: 'c8.common.email' })}
                name={'email'}
                onChange={this.onChangeToggle}
                className={'email'}
                checked={email}
                disabled={isDmsAppt}
              />
            )}
          </Col>
          {text && (
            <Col className={`${ns}__mobile-number`}>
              <form onSubmit={() => {}}>{this.showPhoneNumberField()}</form>
            </Col>
          )}
        </Row>
      </React.Fragment>
    ) : null;
  }
}

RemindersAndUpdates.propTypes = {
  appFlow: PropTypes.string.isRequired,
  appointmentStatus: PropTypes.string,
  contactInfo: PropTypes.object,
  dealerCountryCode: PropTypes.string.isRequired,
  getPhoneNumber: PropTypes.func,
  privacySettings: PropTypes.object,
  getTranslate: PropTypes.func,
  intl: PropTypes.object,
  isFormRemindersValid: PropTypes.bool,
  isMobileObfuscated: PropTypes.bool,
  isModifyEnabledFindMe: PropTypes.bool,
  isObfuscated: PropTypes.bool.isRequired,
  isPopulateMobilePhoneNumber: PropTypes.bool.isRequired,
  mobilePhoneNumberNotPopulated: PropTypes.func.isRequired,
  mobilePhoneNumberModified: PropTypes.func.isRequired,
  obfuscatedBy: PropTypes.string,
  resetObfuscatedContactInfo: PropTypes.func.isRequired,
  setMobilePhoneNumber: PropTypes.func,
  savedMobileNumber: PropTypes.string,
  setObfuscatedBy: PropTypes.func.isRequired,
  setPrivacySettings: PropTypes.func.isRequired,
  showPhoneNumber: PropTypes.string,
  isDmsAppt: PropTypes.bool
};

export default RemindersAndUpdates;



// WEBPACK FOOTER //
// ./src/components/molecules/RemindersAndUpdates/RemindersAndUpdates.js